import { POST_CREATE_OTP_CODE_ROUTE } from "@api-routes/otpVerification";
import { getMobileNumberPortRoute } from "@api-routes/mnpFacade";
import { useFetch } from "@common/hook/useFetch";
import { IPostOtpCodeResult } from "../interface/IPostOtpCodeResult";
import { IGetMobileNumberPortResult } from "../interface/IGetMobileNumberPortResult";

export const usePhoneNumber = (setErrorMessage: (errorMessage: string) => void) => {
    const [, { get, post }] = useFetch();

    const createOtpCode = (phoneNumber: string) =>
        post<IPostOtpCodeResult>(POST_CREATE_OTP_CODE_ROUTE, {
            body: { msisdn: phoneNumber, brand: "GOMO" },
        }).then((result) => {
            if (result?.errorMessage) {
                setErrorMessage(result.errorMessage);

                return undefined;
            }

            return result;
        });

    const validatePhoneNumber = (phoneNumber: string) =>
        get<IGetMobileNumberPortResult>(getMobileNumberPortRoute(phoneNumber)).then((result) => {
            if (result?.errorMessage) {
                setErrorMessage(result.errorMessage);

                return undefined;
            }

            return result;
        });

    return { createOtpCode, validatePhoneNumber };
};
